import { Module } from 'vuex';
import { RootState } from '@/store/rootState';
import { TicketsState } from './ticketsState';
import mutations from './mutations';
import actions from './actions';
import state from './state';
import getters from './getters';

const tickets: Module<TicketsState, RootState> = {
    namespaced: true,
    mutations,
    actions,
    state,
    getters,
};

export default tickets;
